import React from "react";
import { Download, Expand, X } from "lucide-react";

interface MindMapHeaderProps {
  title: string;
  mode: "inline" | "expanded";
  onDownload: () => void;
  onToggleExpand: () => void;
}

export const MindMapHeader: React.FC<MindMapHeaderProps> = ({
  title,
  mode,
  onDownload,
  onToggleExpand,
}) => {
  return (
      <div className={`relative flex justify-center border-b border-border bg-card px-4 py-3 ${mode === "expanded" ? "rounded-t-2xl" : ""}`}>
      <h3 className="text-center text-base font-medium text-foreground">{title}</h3>
      <div className="diagram-buttons absolute right-2 top-2 flex gap-1">
        <button
          onClick={onDownload}
          className="inline-flex h-8 w-8 items-center justify-center text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none hover:bg-accent hover:text-accent-foreground rounded-sm"
          aria-label="Download as PNG"
          title="Download as PNG"
        >
          <Download className="h-4 w-4" />
        </button>
        <button
          onClick={onToggleExpand}
          className="inline-flex h-8 w-8 items-center justify-center text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none hover:bg-accent hover:text-accent-foreground rounded-sm"
          aria-label={mode === "inline" ? "Expand" : "Close"}
          title={mode === "inline" ? "Expand" : "Close"}
        >
          {mode === "inline" ? (
            <Expand className="h-4 w-4" />
          ) : (
            <X className="h-4 w-4" />
          )}
        </button>
      </div>
    </div>
  );
};
